import { OntarioObstetricalFileClickableTextContext } from "@/Common/Models/UI/ClickableTextContext";
import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";
import { OntarioObstetricalFileFieldLimits } from "@/Patient/Components/MedicalNote/ObstetricalFile/Form/Ontario/OntarioObstetricalFileFieldLimits";
import { OntarioObstetricalPostnatalDiscussionTopics } from "@/Patient/Models/ObstetricalFile/Ontario/Postnatal/OntarioObstetricalPostnatalDiscussionTopics";
import { PostnatalDiscussionTopic } from "@/Patient/Models/ObstetricalFile/Ontario/Postnatal/PostnatalDiscussionTopic";

class OntarioObstetricalFilePostnatalDiscussions extends BaseOntarioObstetricalFileSubSection<BaseOntarioObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const postNatalDiscussionTopics = this.props.form.Postnatal?.DiscussionTopics;
        const fieldLimits = OntarioObstetricalFileFieldLimits.Page5;
        return (
            <div className="section border border-bottom border-top">
                <div className="row">
                    <div className="col-xs-6">
                        <h4 className="text-bold">{cacheStore.GetString("ObstetricalFile_DiscussionTopicsLabel")}</h4>
                    </div>
                    <div className="col-xs-6">
                        <h4 className="text-bold">{cacheStore.GetString("CommentsLabel")}</h4>
                    </div>
                </div>
                {this.discussionTopic(
                    "ObstetricalFile_TransitionToParenthoodOrPartnerAdjustmentLabel",
                    postNatalDiscussionTopics?.TransitionToParenthoodOrPartnerAdjustment,
                    (mutation, triggerSave) => this.mutateDiscussion(s => mutation(s.TransitionToParenthoodOrPartnerAdjustment), triggerSave),
                    fieldLimits.Postnatal_DiscussionTopics_TransitionToParenthoodOrPartnerAdjustmentComments.MaxChars,
                    OntarioObstetricalFileClickableTextContext.Postnatal_DiscussionTopicTransitionToParenthoodOrPartner
                )}
                {this.discussionTopic(
                    "ObstetricalFile_FamilyViolenceAndSafetyLabel",
                    postNatalDiscussionTopics?.FamilyViolenceAndSafety,
                    (mutation, triggerSave) => this.mutateDiscussion(s => mutation(s.FamilyViolenceAndSafety), triggerSave),
                    fieldLimits.Postnatal_DiscussionTopics_FamilyViolenceAndSafetyComments.MaxChars,
                    OntarioObstetricalFileClickableTextContext.Postnatal_DiscussionTopicFamilyViolenceSafety
                )}
                {this.discussionTopic(
                    "ObstetricalFile_NutritionOrPhysicialActivityOrHealthyWeightLabel",
                    postNatalDiscussionTopics?.NutritionOrPhysicialActivityOrHealthyWeight,
                    (mutation, triggerSave) => this.mutateDiscussion(s => mutation(s.NutritionOrPhysicialActivityOrHealthyWeight), triggerSave),
                    fieldLimits.Postnatal_DiscussionTopics_NutritionOrPhysicalActivityOrHealthyWeightComments.MaxChars,
                    OntarioObstetricalFileClickableTextContext.Postnatal_DiscussionTopicNutritionOrPhysicialActivity
                )}
                {this.discussionTopic(
                    "ObstetricalFile_PlanForAlcoholTobaccoSubstanceUseManagementLabel",
                    postNatalDiscussionTopics?.PlanForAlcoholTobaccoSubstanceUseManagement,
                    (mutation, triggerSave) => this.mutateDiscussion(s => mutation(s.PlanForAlcoholTobaccoSubstanceUseManagement), triggerSave),
                    fieldLimits.Postnatal_DiscussionTopics_PlanOfManagementOfSubstanceUseComments.MaxChars,
                    OntarioObstetricalFileClickableTextContext.Postnatal_DiscussionTopicPlanForAlcoholTobaccoSubstanceUseManagement
                )}
                {this.discussionTopic(
                    "ObstetricalFile_ContraceptionLabel",
                    postNatalDiscussionTopics?.Contraception,
                    (mutation, triggerSave) => this.mutateDiscussion(s => mutation(s.Contraception), triggerSave),
                    fieldLimits.Postnatal_DiscussionTopics_ContraceptionComments.MaxChars,
                    OntarioObstetricalFileClickableTextContext.Postnatal_DiscussionTopicContraception
                )}
                {this.discussionTopic(
                    "ObstetricalFile_PelvicFloorExercisesLabel",
                    postNatalDiscussionTopics?.PelvicFloorExercises,
                    (mutation, triggerSave) => this.mutateDiscussion(s => mutation(s.PelvicFloorExercises), triggerSave),
                    fieldLimits.Postnatal_DiscussionTopics_PelvicFloorExercisesComments.MaxChars,
                    OntarioObstetricalFileClickableTextContext.Postnatal_DiscussionTopicPelvicFloorExercises
                )}
                {this.discussionTopic(
                    "ObstetricalFile_CommunityResourcesLabel",
                    postNatalDiscussionTopics?.CommunityResources,
                    (mutation, triggerSave) => this.mutateDiscussion(s => mutation(s.CommunityResources), triggerSave),
                    fieldLimits.Postnatal_DiscussionTopics_CommunityResourcesComments.MaxChars,
                    OntarioObstetricalFileClickableTextContext.Postnatal_DiscussionTopicCommunityResources
                )}
                {this.discussionTopic(
                    "ObstetricalFile_AdviceRegardingFuturePregnanciesAndRiskLabel",
                    postNatalDiscussionTopics?.AdviceRegardingFuturePregnanciesAndRisk,
                    (mutation, triggerSave) => this.mutateDiscussion(s => mutation(s.AdviceRegardingFuturePregnanciesAndRisk), triggerSave),
                    fieldLimits.Postnatal_DiscussionTopics_AdviceRegardingFuturePregnanciesAndRisksComments.MaxChars,
                    OntarioObstetricalFileClickableTextContext.Postnatal_DiscussionTopicAdviceRegardingFuturePregnancies
                )}
                {this.discussionTopic(
                    "ObstetricalFile_PreconceptionPlanningLabel",
                    postNatalDiscussionTopics?.PreconceptionPlanning,
                    (mutation, triggerSave) => this.mutateDiscussion(s => mutation(s.PreconceptionPlanning), triggerSave),
                    fieldLimits.Postnatal_DiscussionTopics_PreconceptionPlanningComments.MaxChars,
                    OntarioObstetricalFileClickableTextContext.Postnatal_DiscussionTopicPreconceptionPlanning
                )}
                {this.discussionTopic(
                    "ObstetricalFile_CaesareanSectionFutureModeOfBirthLabel",
                    postNatalDiscussionTopics?.CaesareanSectionFutureModeOfBirth,
                    (mutation, triggerSave) => this.mutateDiscussion(s => mutation(s.CaesareanSectionFutureModeOfBirth), triggerSave),
                    fieldLimits.Postnatal_DiscussionTopics_FutureModeOfBirthAndPregnancySpacingComments.MaxChars,
                    OntarioObstetricalFileClickableTextContext.Postnatal_DiscussionTopicCaesareanSectionFutureModeOfBirth
                )}
                {this.discussionTopic(
                    "ObstetricalFile_OtherCommentsOrConcernsLabel",
                    postNatalDiscussionTopics?.OtherCommentsOrConcerns,
                    (mutation, triggerSave) => this.mutateDiscussion(s => mutation(s.OtherCommentsOrConcerns), triggerSave),
                    fieldLimits.Postnatal_DiscussionTopics_OtherComments.MaxChars,
                    OntarioObstetricalFileClickableTextContext.Postnatal_DiscussionTopicOtherCommentsOrConcerns
                )}
            </div>
        );
    }

    private discussionTopic(label: string, discussiontTopic: PostnatalDiscussionTopic, onChange: (mutation: (topic: PostnatalDiscussionTopic) => void, triggerSave: boolean) => void, dicussionTextMaxLength: number, context: string): JSX.Element {
        const discussionId = `postnatal-discussion-${label}`;
        return (
            <div className="row row-form">
                <div className="col-xs-6">
                    <div>
                        {this.controlRenderer.renderCheckbox(
                            label,
                            discussiontTopic?.IsDiscussed ?? false,
                            value => onChange(topic => topic.IsDiscussed = value, true),
                            "",
                            "fit-content"
                        )}
                    </div>
                </div>
                <div className="col-xs-6">
                    {this.controlRenderer.renderTextbox({
                        id: discussionId,
                        value: discussiontTopic?.Comments ?? "",
                        onChange: value => onChange(topic => topic.Comments = value, false),
                        clickableTextOptions: this.getClickableTextOptions(discussionId, context),
                        maxLength: dicussionTextMaxLength
                    })}
                </div>
            </div>
        );
    }

    private mutateDiscussion(mutation: (state: OntarioObstetricalPostnatalDiscussionTopics) => void, triggerSave: boolean): void {
        if (triggerSave)
            this.props.mutateModelStateWithFormUpdate(s => mutation(s.Postnatal.DiscussionTopics));
        else
            this.props.mutateModelState(s => mutation(s.Postnatal.DiscussionTopics));
    }
}

export { OntarioObstetricalFilePostnatalDiscussions };
